import React from "react";
import { Link } from "react-router-dom";

import Menu from "../menu/Menu";
import "./header.scss";


export default class Header extends React.Component {
  state = {
    isMenuOpen: false
  }

  openMenu() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
    this.props.parentCallback(this.state.isMenuOpen);
    // console.log(this.state.isMenuOpen);
    const bg = this.state.isMenuOpen ? '' : 'active';
    // console.log(bg);
    document.body.className = bg;
  }

  handleMenu = (data) => {
    this.setState({ isMenuOpen: data });
  }

  render() {
    const isMenuActive = this.state.isMenuOpen ? 'active' : '';
    const isMenuClose = this.state.isMenuOpen ? '' : 'closed';
  

    return (
      <header>
        <div className="container">
          <div className="topbar">
            <Link to={"/"} className={`logo ${isMenuActive}`} >
              oneroman
            </Link>
            <div className={`menu-btn ${isMenuActive}`} onClick={() => this.openMenu()}>
              menu
            </div>
            <div className={`menu-block ${isMenuClose}`}>
              {this.state.isMenuOpen ? (
                <Menu parentCallback={this.handleMenu} />
              ) : null}
            </div>
          </div>
        </div>
      </header >
    )
  }
}